<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('studentVehicle.pageTitle') }}</h1>
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="row">
          <div class="col-md-4 col-sm-12">
            <div class="row form-group m-b-15">
              <label class="col-form-label col-md-3 required">
                {{ $t('studentVehicle.vehicle') }}
              </label>
              <a-select
                v-model="model.old_vehicle_id"
                :options="vehicles"
                class="ts-ml-3"
                style="width: 97%;"
                @change="studentVehicleFilter"
              ></a-select>
              <div class="validate ts-ml-3" v-if="errors.has('old_vehicle_id')">
                {{ errors.first('old_vehicle_id') }}
              </div>
            </div>
          </div>
          <div class="col-sm-12 col-md-4 ts-text-center ts-py-10">
            <label>{{ $t('studentVehicle.transferTo') }}</label>
          </div>
          <div class="col-md-4 col-sm-12">
            <div class="row form-group m-b-15">
              <label class="col-form-label col-md-3 required">{{
                $t('studentVehicle.vehicle')
              }}</label>
              <a-select
                v-model="model.transfer_vehicle_id"
                @change="setOperationID"
                :options="vehicles"
                class="ts-ml-3"
                style="width: 97%;"
              ></a-select>
              <div
                class="validate ts-ml-3"
                v-if="errors.has('transfer_vehicle_id')"
              >
                {{ errors.first('transfer_vehicle_id') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="ts-w-full">
            <ts-loading-banner :loading="loading">
              <table class="table ui-table table-hover">
                <thead>
                  <tr>
                    <th style="width: 3%;"></th>
                    <th>
                      {{ $t('studentVehicle.plateNo') }}
                    </th>
                    <th>
                      {{ $t('studentVehicle.driverName') }}
                    </th>
                    <th>
                      {{ $t('studentVehicle.studentName') }}
                    </th>
                    <th>
                      {{ $t('studentVehicle.sexStudent') }}
                    </th>
                  </tr>
                  <tr>
                    <td colspan="5">
                      <input
                        type="text"
                        class="form-control ts-w-full"
                        v-model="searchStudent"
                        :placeholder="$t('studentVehicle.search')"
                      />
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(item, index) in vehicleStudent" :key="index">
                    <td>
                      <ts-checkbox
                        v-model="model.student_id_list"
                        :value="item.student_id"
                      ></ts-checkbox>
                    </td>
                    <td>
                      {{ item.plate_no }}
                    </td>
                    <td>
                      {{ item.name_en }}
                    </td>
                    <td>{{ item.last_name_en }} {{ item.first_name_en }}</td>
                    <td>
                      {{ item.gender }}
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <td>
                    <b class="ts-uppercase">{{ $t('studentVehicle.total') }}</b>
                  </td>
                  <td>
                    <b>{{ vehicleStudent.length }}</b>
                  </td>
                  <td colspan="3"></td>
                </tfoot>
              </table>
              <div
                class="validate ts-ml-3"
                v-if="errors.has('student_id_list')"
              >
                {{ errors.first('student_id_list') }}
              </div>
            </ts-loading-banner>
          </div>
        </div>
        <div class="row mt-3">
          <div class="col-md-12 text-right">
            <ts-button
              class="btn-primary mr-2"
              @click.prevent="update"
              :waiting="saving"
            >
              {{ $t('transfer') }}
            </ts-button>
            <ts-button
              class="btn-default"
              @click="$router.push({ name: 'student-vehicle' })"
            >
              {{ $t('cancel') }}
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapActions } from 'vuex'
export default {
  name: 'student-vehicel-create',
  props: ['value'],
  data() {
    return {
      errors: new Errors(),
      waiting: false,
      loading: false,
      saving: false,
      vehicles: [],
      student_list: [],
      searchStudent: '',
      model: {
        operation_id: '',
        old_vehicle_id: '',
        student_id_list: [],
        transfer_vehicle_id: ''
      }
    }
  },
  computed: {
    vehicleStudent() {
      if (this.searchStudent) {
        return this.student_list.filter(item => {
          return this.searchStudent
            .toLowerCase()
            .split(' ')
            .every(
              v =>
                item.plate_no.toLowerCase().includes(v) ||
                item.name_en.toLowerCase().includes(v) ||
                item.last_name_en.toLowerCase().includes(v) ||
                item.first_name_en.toLowerCase().includes(v)
            )
        })
      } else {
        return this.student_list
      }
    }
  },
  created() {
    this.getVehicle()
  },
  methods: {
    ...mapActions('studentVehicle', ['getStudentRegister']),
    update() {
      this.errors = new Errors()
      this.saving = true
      this.$store
        .dispatch('studentVehicle/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'student-vehicle' })
        })
        .catch(error => {
          this.saving = false
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
    },
    setOperationID(value, props) {
      this.model.operation_id = props.data.props.operation_id
    },
    studentVehicleFilter(value) {
      this.loading = true
      this.getStudentRegister(value)
        .then(response => {
          this.student_list = response
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    },
    vehicleRegister() {
      this.$store.dispatch('studentVehicle/fetch').then(response => {
        this.students = response.data
      })
    },
    getVehicle() {
      this.$store.dispatch('studentVehicle/getVehicle').then(response => {
        this.vehicles = response.data.map(el => ({
          operation_id: el.operation_id,
          value: el.vehicle_id,
          label: el.plate_no + '-' + el.name_en
        }))
      })
    }
  }
}
</script>
